import PropTypes from 'prop-types'
// material
import {
  Box,
  Checkbox,
  TableRow,
  TableCell,
  TableHead,
  TableSortLabel,
} from '@mui/material'

// ----------------------------------------------------------------------

const visuallyHidden = {
  border: 0,
  margin: -1,
  padding: 0,
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
  clip: 'rect(0 0 0 0)',
}

MuiTableHeader.propTypes = {
  order: PropTypes.oneOf(['asc', 'desc']),
  orderBy: PropTypes.string,
  rowCount: PropTypes.number,
  columns: PropTypes.array,
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func,
  onSelectAllClick: PropTypes.func,
  showCheckbox: PropTypes.bool,
}

export default function MuiTableHeader({
  order,
  orderBy,
  rowCount,
  columns,
  numSelected,
  onRequestSort,
  onSelectAllClick,
  showCheckbox,
}) {
  const createSortHandler = property => event => {
    onRequestSort(event, property)
  }

  return (
    <TableHead>
      <TableRow>
        {showCheckbox && (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
            />
          </TableCell>
        )}
        {columns.map((headCell, headCellIndex) => {
        
          return (
            <TableCell
            key={headCell.id || `column-${headCellIndex}`}
              align={headCell.alignHeader ? headCell.alignHeader : 'left'}
              //sortDirection={orderBy === headCell.id ? order : false}
              sx={
                headCellIndex == 0
                  ? { padding: '15px 6px 15px 42px' }
                  : { padding: '15px 6px 15px 6px' }
              }
            >
              <TableSortLabel
               hideSortIcon
               // active={orderBy === headCell.id}
              //  direction={orderBy === headCell.id ? order : 'asc'}
               // onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {/* {orderBy === headCell.id ? (
                  <Box sx={{ ...visuallyHidden }}>
                    {order === 'desc'
                      ? 'sorted descending'
                      : 'sorted ascending'}
                  </Box>
                ) : null} */}
              </TableSortLabel>
            </TableCell>
          )
        })}
      </TableRow>
    </TableHead>
  )
}
